"use client";

import { MenuItem, TextField } from "@mui/material";
import { usePathname, useRouter, useSearchParams } from "next/navigation";

import { getPortfolioAssetCategoryLabel } from "./portfolio-asset-category-labels";

export function PortfolioCategorySwitcher({
  categories,
  value,
}: {
  categories: string[];
  value?: string;
}) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const uniqueCategories = Array.from(new Set(categories.filter(Boolean)));

  return (
    <TextField
      select
      size="small"
      aria-label="Filtrar carteira por tipo de ativo"
      value={value && uniqueCategories.includes(value) ? value : "all"}
      sx={{
        minWidth: { xs: 142, sm: 164 },
        "& .MuiOutlinedInput-root": {
          borderRadius: 999,
          minHeight: 28,
          fontSize: 12,
          fontWeight: 600,
          color: "inherit",
          backgroundColor: "transparent",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "currentColor",
          opacity: 0.38,
        },
        "& .MuiSelect-select": {
          py: "4px !important",
          pr: "28px !important",
          fontSize: "12px",
          fontWeight: 600,
          color: "inherit",
        },
        "& .MuiSvgIcon-root": { fontSize: 16, color: "inherit" },
      }}
      onChange={(event) => {
        const params = new URLSearchParams(searchParams.toString());
        if (event.target.value === "all") params.delete("categoria");
        else params.set("categoria", event.target.value);
        const query = params.toString();
        router.push(query ? `${pathname}?${query}` : pathname);
      }}
    >
      <MenuItem value="all">Todos os ativos</MenuItem>
      {uniqueCategories.map((category) => (
        <MenuItem key={category} value={category}>
          {getPortfolioAssetCategoryLabel(category)}
        </MenuItem>
      ))}
    </TextField>
  );
}
